// This is made for the hero component

'use strict';

import {debounce} from "./helpers";

const $window = $(window);

$('.js-hero-image').on('load', function (e) {
    updateResponsiveBackground(this);
}).trigger('load');

$window.on('resize', debounce(findAllResposiveBackgrounds, 250, false));

function findAllResposiveBackgrounds() {
    $('.js-hero-image').each((index, element) => {
        updateResponsiveBackground(element);
    });
}

function updateResponsiveBackground(image) {

    const $hero = image.closest('.js-hero');
    const imgSrc = image.currentSrc || image.src;

    $($hero).css('background-image', 'url(' + imgSrc + ')');
    $($hero).addClass('is-loaded');
}
